import { DataModelAttributeType } from '@flowx/designer/modules/core/dictionary/data-model.dictionary'
import {
  ComponentIdentifierEnum,
  DisplayOptionsInterface,
  FormFieldsEnum,
} from '@flowx/shared/interfaces'

export const getFormFieldDataModelType = (
  componentIdentifier: ComponentIdentifierEnum | FormFieldsEnum,
  inputType: DisplayOptionsInterface['flowxProps']['inputType']
): DataModelAttributeType => {
  switch (componentIdentifier) {
    case FormFieldsEnum.TEXTAREA:
      return DataModelAttributeType.STRING
    case FormFieldsEnum.DATEPICKER:
      return DataModelAttributeType.DATE_TIME
    case FormFieldsEnum.INPUT:
      return inputType === 'number' ? DataModelAttributeType.INTEGER : DataModelAttributeType.STRING
    case FormFieldsEnum.SELECT:
    case FormFieldsEnum.CHECKBOX:
    case FormFieldsEnum.RADIO:
      return DataModelAttributeType.ENUM
    case FormFieldsEnum.SWITCH:
      return DataModelAttributeType.BOOLEAN
    case FormFieldsEnum.SLIDER:
      return DataModelAttributeType.INTEGER
    default:
      return DataModelAttributeType.STRING
  }
}
